// How a pay period is NAMED everywhere a person sees one.
//
// Owner, 2026-08-17 (L-15): "why are these pay periods showing the wrong week.
// says P19. whats that? its needs to be Payroll Week 35". The `2026-P18` code
// is the database's canonical id (R-10); the number he and ADP work by is
// `adp_week`. So the label leads with the ADP week and carries the dates, which
// keeps it inside R-10 — a bare "Week 35" is still banned, and never appears.
//
// Dates render MM/DD/YYYY (SPEC §13), built from the YYYY-MM-DD string itself,
// never through `new Date(...)` — a bare date string parses as UTC midnight and
// prints as the day before in every US timezone.
//
// docs/payroll/app-period-dates-per-clinic.md: MELM (Lake Mary) runs
// Monday-Sunday, one day later than the other three clinics. A period a
// caller sees for ALL FOUR clinics at once carries `datesByCompany`
// alongside its own shared `startDate`/`endDate` (src/manager_entry.js,
// src/payroll.js); this file picks the current clinic's pair out of it — no
// new date maths, just selecting which pair of already-computed strings to
// render.

export interface LabelledPayPeriod {
  periodCode: string;
  startDate: string;
  endDate: string;
  adpWeek: number | string | null;
  closed: boolean;
  datesByCompany?: Record<string, { startDate: string; endDate: string }>;
}

export function usDate(iso: string): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
  return m ? `${m[2]}/${m[3]}/${m[1]}` : iso;
}

/** The dates to render for one clinic: its own entry in `datesByCompany`
 * when the period carries one, otherwise the period's own shared dates
 * (a single-clinic caller already gets its dates there — see
 * src/manager_entry.js's listManagerEntries). */
export function datesForClinic(
  p: LabelledPayPeriod, clinic?: string | null,
): { startDate: string; endDate: string } {
  const forClinic = clinic ? p.datesByCompany?.[clinic] : undefined;
  return forClinic ?? { startDate: p.startDate, endDate: p.endDate };
}

export function payPeriodLabel(p: LabelledPayPeriod, clinic?: string | null): string {
  const { startDate, endDate } = datesForClinic(p, clinic);
  const head = p.adpWeek === null || p.adpWeek === undefined || p.adpWeek === ''
    ? p.periodCode
    : `Payroll Week ${p.adpWeek}`;
  return `${head} (${usDate(startDate)} – ${usDate(endDate)})${p.closed ? ' — closed' : ''}`;
}
